class InvoiceNotificationToggle
{
    /**
	 * @param selector {string}
	 */
    constructor(selector)
    {
        // selectors
        this.selector = selector;
        this.toggleTriggerSelector = '.js-invoice-notification-toggle-trigger';

        // elements
        this.wrapper = document.querySelector(this.selector);
        this.toggleTrigger = null;

        // api
        this.api = orion.api.customerScalarAttribute;
        this.attributeName = 'deactivate_invoice_notifications_flag';
    }

    init()
    {
        if (!this.wrapper)
        {
            return;
        }

        this.toggleTrigger = this.fetchToggleTrigger();

        this.initToggle();
        this.initEvents();
    }

    initToggle()
    {
        this.disableToggleTrigger();

        let self = this;

        this.api.read(this.attributeName)
            .done(function(attributeValue)
            {
                if (attributeValue == '1')
                {
                    self.toggleTrigger.checked = false;
                }
                else
                {
                    self.toggleTrigger.checked = true;
                }

                self.enableToggleTrigger();
            });
    }

    initEvents()
    {
        this.toggleTrigger.addEventListener('change', this.handleToggleTriggerChange.bind(this));
    }

    /**
	 * @param value {string}
	 */
    updateNotificationAttribute(value)
    {
        this.disableToggleTrigger();

        let self = this;

        this.api.update(this.attributeName, value)
            .done(function()
            {
                self.enableToggleTrigger();
            });
    }

    activateNotifications()
    {
        this.updateNotificationAttribute('0');
    }

    deactivateNotifications()
    {
        this.updateNotificationAttribute('1');
    }

    disableToggleTrigger()
    {
        this.toggleTrigger.setAttribute('disabled', 'disabled');
    }

    enableToggleTrigger()
    {
        this.toggleTrigger.removeAttribute('disabled');
    }

    isToggleActivated()
    {
        return this.toggleTrigger.checked;
    }

    fetchToggleTrigger()
    {
        return this.wrapper.querySelector(this.toggleTriggerSelector);
    }

    handleToggleTriggerChange()
    {
        if (this.isToggleActivated())
        {
            this.activateNotifications();
        }
        else
        {
            this.deactivateNotifications();
        }
    }
}

let toggle = new InvoiceNotificationToggle('.js-invoice-notification-toggle');

toggle.init();
